export default __webpack_public_path__ + "static/logo-ibp-group-edc3629fa47190d8de07c1164ea2681a.svg";